import { cx } from "@/components/ui";
import { countryName } from "@/lib/format";

// Nur die Adressen der SVG-Dateien kommen ins Bundle – der Browser lädt eine Flagge erst, wenn sie angezeigt wird
// (keine Emoji-Flaggen: Windows zeigt sie nur als zwei Buchstaben).
const FLAGS = import.meta.glob<string>("/node_modules/country-flag-icons/3x2/*.svg", { eager: true, query: "?no-inline", import: "default" });
const urlOf = (cc: string) => FLAGS[`/node_modules/country-flag-icons/3x2/${cc.toUpperCase()}.svg`];

/** Kleine Länderflagge; ohne bekannte Flagge nichts. Rein schmückend – der Ländername steht immer daneben bzw. im Tooltip. */
export function Flag({ country, className, title = true }: { country: string | null | undefined; className?: string; title?: boolean }) {
  const url = country ? urlOf(country) : undefined;
  if (!url) return null;
  return (
    <img
      src={url}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      {...(title ? { title: countryName(country!) } : {})}
      className={cx("inline-block h-[0.8em] w-auto rounded-[2px] ring-1 ring-black/10 align-[-0.05em] shrink-0", className)}
    />
  );
}
